module.exports = __webpack_public_path__ + "static/media/axe.22e19726.svg";